export default __webpack_public_path__ + "static/media/hexmarkedsoul.c25a924e.png";